import { inferSourceTitle } from "../outline/outlinePrompt.js";
import { buildSlideExtractUserPrompt, SURF_SLIDE_EXTRACT_SYSTEM, } from "../outline/slideExtractPrompt.js";
import { parseSingleOutlineSection } from "../outline/parseOutline.js";
import { deckSourceContent } from "../model/surfDeck.js";
import { SURF_AGENT_MODEL_ID, SurfCloudAPI, } from "../graphql/surfApi.js";
import { pollSurfAIJob } from "./surfAiJob.js";
async function submitBedrockJob(cfg, feature, prompt, systemText, userText, maxTokens = 4096) {
    await SurfCloudAPI.ensureProfile(cfg);
    const result = await SurfCloudAPI.submitAIJob(cfg, {
        kind: "BEDROCK_CONVERSE",
        provider: "BEDROCK",
        prompt,
        modelId: SURF_AGENT_MODEL_ID,
        feature,
        paramsJson: JSON.stringify({
            bedrock: { systemText, userText, maxTokens },
        }),
        inputAssetKeys: [],
    });
    return pollSurfAIJob(cfg, result.jobId);
}
export async function extractSlideSection(cfg, deck, opts) {
    const source = deckSourceContent(deck).trim();
    if (!source) {
        throw new Error("Nessun contenuto sorgente disponibile per l'estrazione.");
    }
    const title = inferSourceTitle(source) || deck.title;
    const existing = deck.outline ?? [];
    const userText = buildSlideExtractUserPrompt(title, source, existing, opts?.topic);
    const raw = await submitBedrockJob(cfg, "surf.slide.extract", "Estrai sezione slide", SURF_SLIDE_EXTRACT_SYSTEM, userText, 4096);
    return parseSingleOutlineSection(raw);
}
